import { Divider, Flex, FormLabel, Stack } from '@chakra-ui/react'

import CustomFormBuilderCreateQuestion from './components/CustomFormBuilderCreateQuestion'
import CustomFormBuilderQuestionCard from './components/CustomFormBuilderQuestionCard'
import { useCustomFormBuilder } from '../../contexts/CustomFormBuilderManagerContext/Provider'

export default function CustomFormQuestion() {
  const { questions } = useCustomFormBuilder()

  return (
    <Flex flexDir="column" gap={4}>
      <Stack>
        <FormLabel>Questões</FormLabel>
        {questions.map((question, index) => (
          <CustomFormBuilderQuestionCard
            key={index}
            index={index}
            questionsLength={questions?.length}
            question={question}
          />
        ))}
      </Stack>

      <CustomFormBuilderCreateQuestion />

      <Divider />
    </Flex>
  )
}
